import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';

import { ObservableScope } from '../../shared/models/observable-scope.enum';
import { ConfigParserService } from '../../shared/services/config-parser.service';
import { EventService } from '../../shared/services/event.service';
import { AngularEvents } from '../../shared/shared-context/angular-events';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { FirstRunModel } from './shared/first-run.model';

export interface FirstRunConfig {
    alwaysShowInTestMode: boolean;
    microsoftIconPath: string;
    microsoftIconPathDark?: string;
    officeIconPath?: string;
    m365IconPath?: string;
    model: FirstRunModel;
    resources: FirstRunResources;
    version?: string;
}

export interface FirstRunResources {
    FirstRunBackButtonAriaLabel: string;
    FirstRunCloseButtonAriaLabel: string;
    FirstRunCompleteButtonAriaLabel: string;
    FirstRunNextButtonAriaLabel: string;
    FirstRunNextSlideAnnouncementAriaLabel: string;
    FirstRunPaginationAriaLabel: string;
    FirstRunDevicesMessage: string;
    FirstRunWebMessage: string;
    FirstRunMicrosoftIconAlt: string;
    FirstRunOfficeIconAlt: string;
}

@Injectable({
    providedIn: 'root'
})
export class FirstRunConfigService {
    private configPromise: Promise<FirstRunConfig>;

    constructor(
        private readonly configParserService: ConfigParserService,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly eventService: EventService
    ) {
    }

    public getConfig(): Promise<FirstRunConfig> {
        if (!this.configPromise) {
            const parseConfig = () => this.configParserService.parse<FirstRunConfig>('firstRunConfig');
            if (this.capabilitiesService.capabilities.pwaEnabled) {
                this.configPromise = Promise.resolve(parseConfig());
            } else {
                const tokensLoadedPromise = this.eventService.events.withScope(ObservableScope.PastAndFuture).pipe(
                    filter(event => event.name === AngularEvents.primaryTokensLoaded),
                    take(1))
                    .toPromise();
                this.configPromise = tokensLoadedPromise.then(parseConfig);
            }

        }
        return this.configPromise;
    }
}
